import { Typography } from "@mui/material";
import { MaterialReactTable } from "material-react-table";
import PropTypes from "prop-types";
import React, { useMemo } from "react";

const DataTable = ({ data, columns, noDataMessage, title }) => {
  const tableColumns = useMemo(
    () =>
      columns.map((col) => ({
        accessorKey: col.field,
        header: col.headerName,
        Cell: col.Cell ? ({ cell }) => col.Cell(cell.getValue()) : undefined,
        muiTableHeadCellProps: {
          sx: {
            fontWeight: "bold",
            backgroundColor: "#f5f5f5",
            borderRight: "1px solid #e0e0e0",
            "&:last-child": { borderRight: "none" },
          },
        },
        muiTableBodyCellProps: {
          sx: {
            borderRight: "1px solid #e0e0e0",
            "&:last-child": { borderRight: "none" },
          },
        },
      })),
    [columns]
  );

  return (
    <MaterialReactTable
      columns={tableColumns}
      data={data}
      enableStickyHeader
      enableColumnResizing
      enablePagination={false}
      initialState={{
        density: "compact",
      }}
      enableGlobalFilter={true}
      positionGlobalFilter="right"
      positionToolbarAlertBanner="none"
      renderTopToolbarCustomActions={() =>
        title ? (
          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              my: 0,
              pl: 0,
              ml: "-8px",
              fontSize: "1.5rem",
              color: "text.primary",
              lineHeight: 1.2,
            }}
          >
            {title}
          </Typography>
        ) : null
      }
      muiTablePaperProps={{
        elevation: 0,
        sx: {
          border: "none",
          boxShadow: "none",
        },
      }}
      muiTableBodyProps={{
        sx: { "& tr": { borderBottom: "1px solid #f0f0f0" } },
      }}
      muiTableContainerProps={{
        sx: {
          maxHeight: 400,
          overflowX: "auto",
          overflowY: "auto",
          p: 0,
          m: 0,
          "&::-webkit-scrollbar": {
            height: "8px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#b0b0b0",
            borderRadius: "4px",
          },
        },
      }}
      muiTopToolbarProps={{
        sx: {
          px: 0,
          py: 1,
          minHeight: "auto",
          alignItems: "center",
        },
      }}
      muiBottomToolbarProps={{
        sx: { display: "none" },
      }}
      localization={{
        noRecordsToDisplay: noDataMessage,
      }}
    />
  );
};

DataTable.propTypes = {
  data: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  noDataMessage: PropTypes.string,
  title: PropTypes.string,
};

export default DataTable;
